import gql from 'graphql-tag'

export const ADD_ORDER_DETAIL = gql`
 mutation insert_orderDetails($id: uuid!,$orderReadiness: jsonb!,$lrObject: jsonb!,$pickupConfirmation: String!, $pickupPoint: jsonb!, $orderId: uuid!, $internalstatus: uuid!, $orderDetailId: uuid!) {
  insert_orderDetails(objects: {id: $id, orderReadiness: $orderReadiness, lrObject: $lrObject, pickupConfirmation: $pickupConfirmation, pickupPoint: $pickupPoint, orderId: $orderId}) {
    returning {
      id
 }
}
  }
`
export const UPDATE_ORDER_DETAIL = gql`
 mutation ($id: uuid!,$orderReadiness: jsonb!,$lrObject: jsonb!,$pickupConfirmation: String!, $dropPoint: jsonb!,
  $pickupPoint: jsonb!, $orderId: uuid!, $internalstatus: uuid!, $orderDetailId: uuid!) {
  update_orderDetails (
    where: {id: {_eq: $orderDetailId}}
    _set: {orderReadiness: $orderReadiness, lrObject: $lrObject, pickupConfirmation: $pickupConfirmation,
    dropPoint: $dropPoint, pickupPoint: $pickupPoint}
  ) {
    returning {
      id
     }
    } 
  }
`
/* -----------------------  Update Order Detail by adding tempoOrderId -------------- */
export const ASSIGN_TEMPO = gql`
 mutation ($orderDetailId: uuid!, $pickupVehicleAssignId: uuid!) {
  update_orderDetails (
    where: {id: {_eq: $orderDetailId}}
    _set: {pickupVehicleAssignId: $pickupVehicleAssignId}
  ) {
    returning {
      id
     }
    } 
  }
`
export const ASSIGN_TRUCK_TO_PICKUPVEHICLE = gql`
 mutation ($orderDetailId: uuid!, $pickupVehicleAssignId: uuid!) {
  update_orderDetails (
    where: {id: {_eq: $orderDetailId}}
    _set: {pickupVehicleAssignId: $pickupVehicleAssignId}
  ) {
    returning {
      id
     }
    } 
  }
`
/* ------------ x---------------x--------------x--------------------x------------------ */
/* -----------------------  Update Order Detail by adding truckOrderId -------------- */
export const ASSIGN_TRUCK = gql`
 mutation ($orderDetailId: uuid!, $transportVehicleAssignId: uuid!) {
  update_orderDetails (
    where: {id: {_eq: $orderDetailId}}
    _set: {transportVehicleAssignId: $transportVehicleAssignId}
  ) {
    returning {
      id
     }
    } 
  }
`
/* ------------ x---------------x--------------x--------------------x------------------ */

export const REJECT_ORDER = gql`
 mutation ($orderId: uuid!, $internalstatus: uuid!, $rejectionNote: String!) {
  update_orderDetails (
    where: {orderId: {_eq: $orderId}}
    _set: {rejectionNote: $rejectionNote}
  ) {
    returning {
      id
     }
    } 
update_orders (
    where: {id: {_eq: $orderId}}
    _set: {internalstatus: $internalstatus}
  ) {
    returning {
      id
      orderNumber
     }
    } 
  }
`
export const ADD_ORDER_DETAIL_UPDATE_ORDER = gql`
 mutation ($id: uuid!,$orderReadiness: jsonb!,$lrObject: jsonb!,$pickupConfirmation: String!, $dropPoint: jsonb!, 
 $pickupPoint: jsonb!, $orderId: uuid!, $internalstatus: uuid!, $orderDetailId: uuid!, $rejectionNote: String!) {
  insert_orderDetails(objects: {id: $id, orderReadiness: $orderReadiness, lrObject: $lrObject, dropPoint: $dropPoint,
   pickupConfirmation: $pickupConfirmation, pickupPoint: $pickupPoint, orderId: $orderId, rejectionNote: $rejectionNote}) {
    returning {
      id
 }
}
update_orders (
    where: {id: {_eq: $orderId}}
    _set: {internalstatus: $internalstatus}
  ) {
    returning {
      id
      orderNumber
     }
    } 
  }
`

export const UPDATE_ORDER_DETAIL_UPDATE_ORDER = gql`
 mutation ($id: uuid!,$orderReadiness: jsonb!,$lrObject: jsonb!,$pickupConfirmation: String!, 
  $pickupPoint: jsonb!, $orderId: uuid!, $internalstatus: uuid!, $orderDetailId: uuid!,  $rejectionNote: String!) {
update_orderDetails (
    where: {id: {_eq: $orderDetailId}}
    _set: {orderReadiness: $orderReadiness, lrObject: $lrObject, pickupConfirmation: $pickupConfirmation,
     pickupPoint: $pickupPoint, rejectionNote: $rejectionNote}
  ) {
    returning {
      id
     }
    } 
update_orders (
    where: {id: {_eq: $orderId}}
    _set: {internalstatus: $internalstatus}
  ) {
    returning {
      id
      orderNumber
     }
    } 
  }
`